import { render, staticRenderFns } from "./IncidentBanner.vue?vue&type=template&id=7118df46&scoped=true&"
import script from "./IncidentBanner.vue?vue&type=script&lang=js&"
export * from "./IncidentBanner.vue?vue&type=script&lang=js&"
import style0 from "./IncidentBanner.vue?vue&type=style&index=0&id=7118df46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7118df46",
  null
  
)

export default component.exports